import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link, Redirect } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TopoEstatico from '../Layout/TopoEstatico';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import DatePicker from 'react-bootstrap-date-picker';
import RequestApi from '../Miscelania/RequestApi';
import ExamAcoes from './Elements/ExamAcoes';
import ExamButtonOpen from './Elements/ExamButtonOpen';

class ExamsIndex extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeDatePicker(value, formattedValue) {
    this.setState({
      date: value,
      date_str: formattedValue,
    });
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      dados: [],
      lista_materias: [],
      lista_turmas: [],
      date: null,
      date_str: new Date().toISOString().slice(0,10),
      prova_selecionada: '',
      exam_start: '',
      exam_finish: '',
      matter_id: '',
      team_id: '',
    };
    this.desativar_loading = this.desativar_loading.bind(this);
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.buscarProvas = this.buscarProvas.bind(this);
    this.provas = this.provas.bind(this);
    this.ListaMaterias = this.ListaMaterias.bind(this);
    this.ListaTurmas = this.ListaTurmas.bind(this);
    this.confirmarTodasProvas = this.confirmarTodasProvas.bind(this);
    this.recarregarPagina = this.recarregarPagina.bind(this);
    this.recarregarProvas = this.recarregarProvas.bind(this);
    this.travarProva = this.travarProva.bind(this);
    this.botaoTravar = this.botaoTravar.bind(this);
    this.botaoLiberar = this.botaoLiberar.bind(this);
    this.liberarProva = this.liberarProva.bind(this);
    this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
    this.getNow = this.getNow.bind(this);
  }

  componentDidMount () {
    var self = this;
    self.provas();
    localStorage.setItem("prova", JSON.stringify(''));
  }

  getNow() {
    var currentdate = new Date(); 
    var datetime = ("0" + currentdate.getDate()).slice(-2) + "/"
                    + ("0" + (currentdate.getMonth()+1)).slice(-2)  + "/" 
                    + currentdate.getFullYear() + " "  
                    + currentdate.toLocaleTimeString('en-GB', { hour: "numeric", minute: "numeric"})
                    + ':00';
    return datetime;
  }

  // Buscar infos das provas
  buscarProvas(responseJsonPrev) {
    this.setState({status_loading: 1});
    var dados_salvar = {
      date: this.state.date_str,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/instrutor/data', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
          self.ListaMaterias();
          self.ListaTurmas();
          self.setState({status_loading: 0});
          if (typeof responseJsonPrev.message !== 'undefined') {
            self.setState({mensagem_alerta: responseJsonPrev.message});
            self.setState({tipo_alerta: responseJsonPrev.status});  
            self.setState({status_alerta: 1});
          }
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Buscar infos das provas
  provas(responseJsonPrev) {
    this.setState({status_loading: 1});
    var storage = localStorage.getItem("cid");
    storage = JSON.parse(storage);
    var url = config.get('api') + '/provas/instrutor/data'+storage.aid;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var dados_salvar = {
      date: this.state.date_str,
    };
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/instrutor/data', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
          self.ListaMaterias();
          self.ListaTurmas();
          self.setState({status_loading: 0});
          if (typeof responseJsonPrev !== 'undefined') {
            self.setState({mensagem_alerta: responseJsonPrev.message});
            self.setState({tipo_alerta: responseJsonPrev.status});  
            self.setState({status_alerta: 1});
          }
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ListaMaterias(event) {
    var dados_salvar = {
      data: this.state.dados,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/materias/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ListaTurmas(event) {
    var dados_salvar = {
      dados: this.state.dados,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/turmas/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_turmas: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  travarProva(event) {
    if (window.confirm('Tem certeza que deseja travar a prova do aluno?')) {
      var id = event;
      var dados_salvar = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/retirar/disponibilidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: 'Prova travada com sucesso. A prova do aluno se encerrará automaticamente.'});
          self.setState({tipo_alerta: responseJson.status});
          self.provas();
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  liberarProva(event) {
    if (window.confirm('Tem certeza que deseja liberar a prova interrompida inadvertidamente pelo aluno (ex.: Fechou o navegador)? O cronômetro da prova será zerado. Só terá efeito se a prova ainda não tiver sido finalizada')) {
      var id = event;
      var dados_salvar = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/liberar/disponibilidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: 'Prova liberada com sucesso. A prova do aluno já pode ser reiniciada.'});
          self.setState({tipo_alerta: responseJson.status});
          self.provas();
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  confirmarTodasProvas(event) {
    event.preventDefault();
    this.setState({status_loading: 1});
    
    var dados_salvar = {
      date_str: this.state.date_str,
      matter_id: this.state.matter_id,
      team_id: this.state.team_id,
      exam_start: this.state.exam_start,
      exam_finish: this.state.exam_finish,
    };
    
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/instrutor/confirmar_todas', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.provas(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  recarregarPagina(event){
    this.provas();
  }

  recarregarProvas(dados){
    this.provas();
  }

  botaoEdicao (cell, row) {
    var self = this;
    var botao = '';
    {(row.status === 'reprovada') ? botao = <ExamAcoes dadosProva={row} recarregarProvas={self.recarregarProvas} /> : (row.status === 'aprovada') ? botao = <ExamAcoes dadosProva={row} recarregarProvas={self.recarregarProvas} /> : (row.hour_exam_started !== null && row.hour_exam_finish === null) ? botao = <button title="Prova iniciada. Nenhuma ação possível" alt="Prova liberada para realização. Nenhuma ação possível." value={row.id} onClick={''} className='btn btn-xs disabled'><i className="fa fa-fw fa-warning fa-spinner fa-spin"></i></button> : (row.status !== 'confirmada') ? botao = <ExamButtonOpen dadosProva={row} recarregarProvas={self.recarregarProvas} /> : (row.status_str === 'Indisponível') ? botao = <ExamButtonOpen dadosProva={row} recarregarProvas={self.recarregarProvas} /> : botao = <button title="Prova liberada para realização. Nenhuma ação possível." alt="Prova liberada para realização. Nenhuma ação possível." value={row.id} onClick={''} className='btn btn-xs btn-warning disabled'><i className="fa fa-fw fa-warning"></i></button> }
    return botao;
  }

  botaoTravar (cell, row) {
    var botao = '';
    botao = <button title="Interromper prova do aluno" alt="Interromper prova do aluno" value={row.id} onClick={() => {this.travarProva(row.id)}} className='btn btn-xs btn-danger'><i className="fa fa-fw fa-trash"></i></button>
    return botao;
  }

  botaoLiberar (cell, row) {
    var botao = '';
    botao = <button title="Liberar prova para o aluno" alt="Liberar prova para o aluno" value={row.id} onClick={() => {this.liberarProva(row.id)}} className='btn btn-xs btn-success'><i className="fa fa-fw fa-check"></i></button>
    return botao;
  }

  staffName (cell, row) {
    var staff_name = row.staff.name;

    return staff_name;
  }
  trainingName (cell, row) {
    var training_name = 'Prova avulsa';
    if (row.training !== null) {
      training_name = row.training.name;
    }

    return training_name;
  }
  matterName (cell, row) {
    var matter_name = row.matter.name;

    return matter_name;
  }
  teamName (cell, row) {
    var team_name = 'Prova avulsa';
    if (row.team !== null) {
      team_name = row.team.name;
    }

    return team_name;
  }

  render() {
    var self = this;
    return (
<div>
  <TopoEstatico />
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading !== 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta === 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <section id="provas">
    <div className="container">
      <div className="row formulario-confirmar-todas-provas">
        <div className="col-md-6 col-md-offset-3">
          <label>Data:</label>
          <DatePicker onChange={this.handleChangeDatePicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="DD/MM/YYYY" value={this.state.date} />
          <button onClick={this.buscarProvas} className="btn btn-info btn-block"><i className="fa fa-fw fa-refresh"></i> Buscar provas</button>
        </div>
      </div>
      <hr/>
       <div className="row">
          <form onSubmit={this.confirmarTodasProvas}>
            <div className="col-md-2">
              <Select
                className="form-field-name"
                name="matter_id"
                value={this.state.matter_id}
                searchable={true}
                placeholder={'Selecionar matéria'}
                onChange={this.handleSelectChange.bind(this, 'matter_id')}
                options={this.state.lista_materias}
              />
            </div>
            <div className="col-md-2">
              <Select
                className="form-field-name"
                name="team_id"
                value={this.state.team_id}
                searchable={true}
                placeholder={'Selecionar turma'}
                onChange={this.handleSelectChange.bind(this, 'team_id')}
                options={this.state.lista_turmas}
              />
            </div>
            <div className="col-md-3 form-group">
              <div className="input-group">
                <InputMask value={this.state.exam_start}  maskChar={null} name="exam_start" mask="99/99/9999 99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'exam_start')} placeholder="Data e Horário de início do prazo"/>
                <div className="input-group-addon" style={{cursor: 'pointer'}} onClick={() => this.setState({exam_start: this.getNow()})}><i className="fa fa-calendar"></i></div>
              </div>
            </div>
            <div className="col-md-3 form-group">
              <div className="input-group">
                <InputMask value={this.state.exam_finish}  maskChar={null} name="exam_finish" mask="99/99/9999 99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'exam_finish')} placeholder="Data e Horário de fim do prazo"/>
                <div className="input-group-addon" style={{cursor: 'pointer'}} onClick={() => this.setState({exam_finish: this.getNow()})}><i className="fa fa-calendar"></i></div>
              </div>
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-check"></i> Lançar provas</button>
            </div>
        </form>
      </div>
      <hr className="instrutor-hr" />
      <div>
        <button onClick={this.recarregarPagina} className="btn btn-info btn-lg btn-block"><i className="fa fa-fw fa-refresh"></i> Recarregar provas</button>
      </div>
      <hr className="instrutor-hr" />
      <br/>
    </div>
    <div className="container-fluid">
      <div className="provas-quadrados-fundo">
        <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há provas no momento.'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

          <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoLiberar} width='50'></TableHeaderColumn>
          <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>Cód.</TableHeaderColumn>
          <TableHeaderColumn dataField='staff_name' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Aluno</TableHeaderColumn>
          <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Status</TableHeaderColumn>
          <TableHeaderColumn dataField='team_name' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>
          <TableHeaderColumn dataField='matter_name' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>
          <TableHeaderColumn dataField="exam_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Prazo de Realização - Início</TableHeaderColumn>
          <TableHeaderColumn dataField="exam_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Prazo de Realização - Fim</TableHeaderColumn>
          <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='50'></TableHeaderColumn>
          <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoTravar} width='50'></TableHeaderColumn>
        </BootstrapTable>
      </div>
    </div>   
  </section>
</div>
    );
  }
}

export default ExamsIndex;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamsIndex.js